import { Box, Button, Modal, SpaceBetween } from "@cloudscape-design/components";
import { ReactNode } from "react";

interface ConfirmActionModalProps {
  visible: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
  loading?: boolean;
  header: string;
  confirmLabel?: string;
  confirmDisabled?: boolean;
  children?: ReactNode;
}

/**
 * Generic, presentational confirmation modal shared across pages.
 *
 * It performs no API calls itself — the parent supplies `onConfirm` and owns the
 * actual action logic, loading state, and body content. The footer renders a
 * `Cancel` link and a primary confirm button that honours both `loading` and
 * `confirmDisabled`.
 */
export default function ConfirmActionModal({
  visible,
  onDismiss,
  onConfirm,
  loading = false,
  header,
  confirmLabel = "Confirm",
  confirmDisabled = false,
  children,
}: ConfirmActionModalProps) {
  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      header={header}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onDismiss}>Cancel</Button>
            <Button
              variant="primary"
              onClick={onConfirm}
              loading={loading}
              disabled={confirmDisabled}
            >
              {confirmLabel}
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      {children}
    </Modal>
  );
}
